import { Flex, Image, Text } from "@mantine/core";
import styles from "./PausedScreen.module.css";

/**
 * Copy shown when a candidate reaches a paused location. Shared so the start
 * (ChatContainer) and resume (ResumePage) flows can't drift apart. It doubles
 * as the translation key passed to each flow's translator.
 */
export const NOT_ACCEPTING_CANDIDATES_MESSAGE =
  "Sorry, we aren't currently accepting new candidates for this role.";

interface PausedScreenProps {
  message: string;
  "data-testid"?: string;
}

/**
 * Paused-location screen for the 3.0 interviewer. Mirrors the 2.0 screener's
 * "not accepting candidates" page: a centered illustration above a short
 * message, with no call-to-action button.
 */
export const PausedScreen = ({
  message,
  "data-testid": testId,
}: PausedScreenProps) => (
  <Flex
    className={styles.pausedScreen}
    direction="column"
    align="center"
    justify="center"
    data-testid={testId}
  >
    <Image src="/no-more-applicants.svg" alt="" w={200} h={202} fit="contain" />
    <Text className={styles.message}>{message}</Text>
  </Flex>
);
